import { getContext } from '@fiverr-private/fiverr_context';

const SKIP_QUESTIONNAIRE_QUERY_PARAM = 'skip_questionnaire';

export const useSkipQuestionnaireQueryParam = () => {
    const { queryParameters } = getContext();
    return queryParameters[SKIP_QUESTIONNAIRE_QUERY_PARAM] === 'true';
};
